let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eeN8y")).then(() => parcelRequire('9DLCE'));